import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="О игре" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Основано на -{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
        >
          react-wordle
        </a>{' '}
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Вдохновлено -{' '}
        <a href="https://huerdl.herokuapp.com/" className="underline font-bold">
          huerdl
        </a>{' '}
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-300">Г</p>
    </BaseModal>
  )
}
